// app/components/CategoryMenu.tsx
'use client';
import Image from 'next/image';
import { useRouter } from 'next/navigation';

interface CategoryItem {
  id: string;
  name: string;
  icon: string;
  href: string;
}

const CategoryMenu = () => {
  const router = useRouter();

  const categories: CategoryItem[] = [
    // Row 1
    {
      id: 'zakat',
      name: 'Zakat',
      icon: '/assets/img/categories/icon_zakat2.png',
      href: '/zakat'
    },
    {
      id: 'infaq',
      name: 'Infaq',
      icon: '/assets/img/categories/icon_infaq.png',
      href: '/infaq'
    },
    {
      id: 'sedekah-subuh',
      name: 'Sedekah Subuh',
      icon: '/assets/img/categories/icon_sedekah_shubuh.png',
      href: '/sedekah-subuh'
    },
    {
      id: 'sedekah-lansia',
      name: 'Sedekah Lansia',
      icon: '/assets/img/categories/icon_sedekah_lansia.png',
      href: '/qrta'
    },
    // Row 2
    {
      id: 'fidyah',
      name: 'Fidyah',
      icon: '/assets/img/categories/icon_bayar_fidyah.png',
      href: '/fidyah'
    },
    {
      id: 'wakaf-quran',
      name: 'Wakaf Quran',
      icon: '/assets/img/categories/icon_wakaf_quran.png',
      href: '/wakaf'
    },
    {
      id: 'sedekah-jumat',
      name: 'Sedekah Jumat',
      icon: '/assets/img/categories/icon_sedekah_jumat.png',
      href: '/sedekah-jumat'
    },
    {
      id: 'lainnya',
      name: 'Lainnya',
      icon: '/assets/img/categories/icon_lebih_banyak.png',
      href: '/lainnya'
    }
  ];

  const handleCategoryClick = (category: CategoryItem) => {
    // Navigate without page refresh using Next.js router
    router.push(category.href);
  };

  return (
    <div className="bg-white rounded-2xl px-8">
      {/* Section Title */}
      <div className="mb-2">
        <h3 className="font-bold text-lg text-gray-900 mb-1 font-poppins">
          Kategori Donasi
        </h3>
      </div>

      {/* Category Grid */}
      <div className="grid grid-cols-4 gap-4">
        {categories.map((category) => (
          <button
            key={category.id}
            onClick={() => handleCategoryClick(category)}
            className="group flex flex-col items-center space-y-3 rounded-xl hover:bg-gray-50 transition-all duration-300 border border-transparent hover:border-gray-200 focus:outline-none focus:ring-2 focus:ring-orange-300 focus:bg-orange-50"
          >
            {/* Icon Container */}
            <div className="w-16 h-16 rounded-xl flex items-center justify-center group-hover:bg-gray-200 transition-all duration-300 group-hover:scale-105">
              <Image
                src={category.icon}
                alt={category.name}
                width={40}
                height={40}
                className="w-full h-full object-contain transition-all duration-300 group-hover:scale-110"
              />
            </div>

            {/* Label */}
            <span className="text-xs font-semibold text-gray-700 text-center leading-tight group-hover:text-gray-900 transition-colors duration-300 font-poppins">
              {category.name}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategoryMenu;